import React from "react";

import "./Topbar.css";

const Topbar = () => {
  return (
    <section id="topbar" className="topbar d-flex justify-content-center align-items-center">
      <div className="container-fluid row row-cols-md-3 ">
        <div className="col contact-info d-flex justify-content-center align-items-center">
          <i className="bi bi-envelope d-flex align-items-center">
            <a href="mailto:tjmearplugs@hotmail.com">tjmearplugs@hotmail.com</a>
          </i>
          <i className="bi bi-phone d-flex align-items-center ms-4">
            <a href="tel:+541138054707" style={{ color: "inherit" }}>+54 11 3805 4707</a>
          </i>
        </div>
        <div className="col d-flex justify-content-center">
          <i className="bi bi-truck mx-1"></i> <p className="info-shipping-topbar">Envíos a CABA y GBA en 24hs hábiles</p>
        </div>
        <div className="col social-links d-none d-md-flex d-flex justify-content-center align-items-center">
          <a
            href="https://www.facebook.com/EarplugsTapones"
            target="_blank"
            rel="noreferrer noopener"
            className="facebook"
          >
            <i className="bi bi-facebook"></i>
          </a>
          <a
            href="https://www.instagram.com/earplugs_tjm/"
            target="_blank"
            rel="noreferrer noopener"
            className="instagram"
          >
            <i className="bi bi-instagram"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Topbar;
